export default class ClientEditController {
    constructor($scope, $location, $routeParams, $route, $window, $mdDialog, clientService, userService, authenticationService, notificationsService, globalConstants) {
        this.scope = $scope;
        this.$location = $location;
        this.clientService = clientService;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.$route = $route;
        this.$window = $window;
        this.$routeParams = $routeParams;
        this.$mdDialog = $mdDialog;
        this.globalConstants = globalConstants;
        this.notificationsService = notificationsService;
        this.client = [];
        
        clientService.get($routeParams.id).then(resp => {
            this.client = resp.data;
            this.clientName = this.client.name; // used if editing client name is cancelled
            this.userService.getByIds({ids: this.client.clientTrainers}).then(resp => {
                this.client.clientTrainers = resp.data;
            });
        }, error => {
            $location.path("/");
        });
    }

    onSave() {
        this.clientService.update(this.client).then(resp => {
            this.$route.reload();
        });
    }

    delete() {
        this.clientService.delete(this.$routeParams.id).then(resp => {
            this.$window.location.href = "#!/manage/";
        });
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteClientDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteClientDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    addTrainer()
    {
        this.$window.location.href = '#!/manage/clients/' + this.$routeParams.id + '/trainers/add';
    } 

    assignTrainer(ev) {
        let that = this;
        var selectedTrainers = [];
        for(var clientTrainer of that.client.clientTrainers) {
            selectedTrainers.push(clientTrainer);
        }
        this.$mdDialog.show({
            controller: AssignUserDialogController,
            templateUrl: '/views/components/clients/client-edit.assignuser.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                selected: selectedTrainers
            }
          })
          .then(function(trainers) {
            var i = 0;
            function assignTrainer(trainer) {
                var clientTrainer = {
                    clientId: that.$routeParams.id,
                    trainerId: trainer.id
                };
                that.clientService.assignTrainer(clientTrainer).then(resp => {
                    clientTrainer.user = trainer;
                    if(i == trainers.length - 1) {
                        that.$route.reload();
                        that.notificationsService.show(`Trainer${trainers > 1 ? 's' : ''} assigned to event`, "success")
                    } else {
                        assignTrainer(trainers[++i])
                    }
                });
            }

            if(trainers.length > 0)
                assignTrainer(trainers[0]);
          }, function() {
            
          });
    }

    unassignTrainer(trainer, index) {
        var clientTrainer = {
            clientId: this.$routeParams.id,
            trainerId: trainer.id
        };
        this.clientService.unassignTrainer(clientTrainer).then(resp => {
            this.$route.reload();
        });
    }
    // delete() {
    //     this.eventService.delete(this.$routeParams.eventId).then(resp => {
    //         this.$window.location.href = "#!/manage/clients/edit/" + this.$routeParams.clientId;
    //     });
    // }
}

    class AssignUserDialogController {
        constructor($scope, $routeParams, userService, $mdDialog, selected) {
            $scope.ctrl = this;
            this.$mdDialog = $mdDialog;
    
            userService.getTrainersBySubscriptionId().then(resp => {
                this.trainers = [];
                for(let trainer of resp.data) {
                    let alreadySelected = false;
                    for(let selectedTrainer of selected) {
                        if(trainer.id == selectedTrainer.id)
                            alreadySelected = true;
                    }
                    if(!alreadySelected)
                    {
                        this.trainers.push(trainer);
                    }
                }
            });
        }
    
        accept(trainer) {
            var assignedTrainers = this.trainers.filter(f => f.assign == true);
            this.$mdDialog.hide(assignedTrainers);
        }
    
        cancel() {
            this.$mdDialog.cancel();
        }
}


// WEBPACK FOOTER //
// ./src/js/components/clients/clients.edit.controller.js